import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as jnb from 'react-bootstrap';
import PublicHeader from '../Header/PublicHeader';
import axios from 'axios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';


export default function TradeSbiPayment() {

  const query = new URLSearchParams(useLocation().search);

  // ✅ Get mobile number from URL
  const mobileNumber = query.get('mobile');
console.log("Mobile Number from URL: ", mobileNumber);
  let navigate = useNavigate();

  useEffect(() => {
    paymentProd(mobileNumber);
  }, []);


  function paymentProd(mobileNumber) {
    try {
      axios.get(config.url.BOC_URL + "boc-public/trade-payment?mobile=" + mobileNumber)
        .then((response) => {
          console.log("Response: ", response);
          let resData = response.data.encrypted_string;
          let merchantId = response.data.merchant_id;
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = "https://epay.sbi.bank.in/secure/AggregatorHostedListener";
          const inputMerchantId = document.createElement('input');
          inputMerchantId.type = 'hidden';
          inputMerchantId.name = 'merchIdVal';
          inputMerchantId.id = 'merchIdVal';
          inputMerchantId.value = merchantId;
          form.appendChild(inputMerchantId);
          const inputEncryption = document.createElement('input');
          inputEncryption.type = 'hidden';
          inputEncryption.name = 'EncryptTrans';
          inputEncryption.id = 'EncryptTrans';
          inputEncryption.value = resData;
          form.appendChild(inputEncryption);
          document.body.appendChild(form);
          form.submit();
        })
        .catch((error) => {
          console.log("Error during API request:", error);
        });
    } catch (error) {
      console.log("Unexpected error during payment setup:", error);
    }
  }

  return (
    <>
      <PublicHeader />

      <div className="main_section"></div>

      <jnb.Container className="mt-1">
        <jnb.Row>
          <jnb.Col className="page-titlespacing d-flex justify-content-between px-0">
            <div className="inner-herbpage-service-title1">
              {/* <h1>Mobile Details</h1> */}
            </div>
            <div className="text-right">
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => { navigate('/WorkerRegistrationForm') }}
              >
                Back
              </button>
            </div>
          </jnb.Col>
        </jnb.Row>
      </jnb.Container>

      <jnb.Container className="outer-page-content-container">
        <div className='text-center mx-5'>

          <jnb.Row className="pt-1">
            <div className="d-flex justify-content-center align-items-center">

              <div className="table-responsive" style={{ width: '60%' }}>
                <table
                  className="table table-bordered table-striped table-hover mb-0 mt-4"
                  style={{
                    border: '3px solid lightblue',
                    width: '100%',
                    borderCollapse: 'collapse',
                  }}
                >
                  <thead>
                  </thead>

                  <tbody>
                    {/* <tr>
                      <th style={{ width: '50%' }}>Mobile Number</th>
                      <td>{mobileNumber ? mobileNumber : 'N/A'}</td>
                    </tr> */}
                    <tr>
                      <td colSpan="2">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "14px",
                            padding: "18px",
                            background: "#f4f6f9",
                            borderRadius: "10px",
                            fontWeight: "600",
                            fontSize: "18px", // 👈 increased text size
                            color: "#222",
                            boxShadow: "0 3px 8px rgba(0,0,0,0.1)"
                          }}
                        >
                          {/* Spinner */}
                          <div
                            style={{
                              width: "22px",  // 👈 slightly bigger spinner
                              height: "22px",
                              border: "3px solid #ccc",
                              borderTop: "3px solid #007bff",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite"
                            }}
                          ></div>

                          <span>Redirecting to payment page, please wait...</span>
                        </div>

                        {/* Spinner Animation */}
                        <style>
                          {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
                        </style>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>

            </div>
          </jnb.Row>

        </div>
      </jnb.Container>
    </>
  );
}
